var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInputEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.373,
    height: 16.007,
    viewBox: "0 0 20.373 16.007",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "input-email",
    transform: "translate(0 -54.82)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14831",
    "data-name": "Group 14831",
    transform: "translate(0 54.82)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3090",
    "data-name": "Path 3090",
    d: "M1.955,59.754q.387.273,2.331,1.62t2.979,2.075q.114.08.483.347t.614.432q.244.165.591.369a3.43,3.43,0,0,0,.654.307,1.8,1.8,0,0,0,.568.1H10.2a1.8,1.8,0,0,0,.569-.1,3.433,3.433,0,0,0,.654-.307q.347-.2.591-.369t.614-.432q.369-.267.483-.347l5.321-3.695a5.4,5.4,0,0,0,1.387-1.4,3,3,0,0,0,.557-1.716,1.834,1.834,0,0,0-1.819-1.819H1.819a1.624,1.624,0,0,0-1.347.591A2.3,2.3,0,0,0,0,56.889a2.656,2.656,0,0,0,.625,1.552A5.643,5.643,0,0,0,1.955,59.754Z",
    transform: "translate(0 -54.82)",
    fill: "#333537"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3091",
    "data-name": "Path 3091",
    d: "M19.236,185.426q-3.729,2.524-5.662,3.922-.648.477-1.052.745a6.489,6.489,0,0,1-1.074.546,3.271,3.271,0,0,1-1.25.279h-.023a3.272,3.272,0,0,1-1.251-.279,6.492,6.492,0,0,1-1.074-.546q-.4-.267-1.052-.745-1.535-1.125-5.65-3.922A6.021,6.021,0,0,1,0,184.437v9.027a1.751,1.751,0,0,0,.534,1.285,1.751,1.751,0,0,0,1.285.534H18.554a1.825,1.825,0,0,0,1.819-1.819v-9.027A6.269,6.269,0,0,1,19.236,185.426Z",
    transform: "translate(0 -179.276)",
    fill: "#333537"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputEmail);
export default __webpack_public_path__ + "static/media/input-email.9cf0f19be1bfebc8c362319e54c567ba.svg";
export { ForwardRef as ReactComponent };